import { supabase } from '@/lib/supabase';

export type Role = {
  id: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
};

const rolesService = {
  async getAll(): Promise<Role[]> {
    const { data, error } = await supabase
      .from('job_titles')
      .select('id, name, sort_order, is_active')
      .eq('is_active', true)
      .order('sort_order', { ascending: true });

    if (error) throw error;

    return (data ?? []).map((r: any) => ({
      id: r.id,
      name: r.name,
      sortOrder: r.sort_order,
      isActive: r.is_active,
    }));
  },
};

export default rolesService;
